import $                    from 'jquery';
import cx                   from 'classnames';
import { isApp, isMobile }  from 'utils/util';
import React, { PropTypes } from 'react';
import ReactDom             from 'react-dom';
import ResizesImages        from 'mixins/resizes_images';
import VideoActions         from 'actions/video_actions';
import VideoStore           from 'stores/video_store';

export default React.createClass({
  displayName: 'Player.Screen',
  propTypes: {
        videoElementId: PropTypes.string,
             isPlaying: PropTypes.bool,
               isEnded: PropTypes.bool,
    hideControlsMobile: PropTypes.bool,
                 video: PropTypes.object
  },
  mixins: [ ResizesImages ],
  componentDidMount() {
    VideoActions.load(this.props.videoElementId, this.props.video);
    const node       = ReactDom.findDOMNode(this),
          { poster } = this.props.video;
    let width  = node.offsetWidth,
        height = node.offsetHeight;
    if(isMobile()) {
      width  *= 2;
      height *= 2;
    }
    node.style.backgroundImage = this.resizeImageTo(poster, `${width}x${height}`, 'style');
  },
  componentDidUpdate() {
    if(isApp() || isMobile()) {
      $('video').attr('autoplay', true);
      $('video').attr('playsinline', 'playsinline');
      $('video').attr('webkit-playsinline', 'webkit-playsinline');

      if(this.props.video.autoplay){
        $('#video_player_screen').removeClass('is-paused');
        $('.video-player-standalone, .video-player-play-button').addClass('is-playing');
      }
    }

    if(this.props.hideControlsMobile) {
      $('video').removeAttr('controls');
    }
    // Akamai bugged. They probobly wont fix.
    // Our custom paused/play is more reliable so we use it to fix akamai.
    //$('#'+this.props.videoElementId).toggleClass('akamai-paused', $('#video_player_screen').hasClass('is-paused'));
    const videoPlayer = document.getElementById(this.props.videoElementId),
          videoPlayerScreen = document.getElementById('video_player_screen'),
          videoPoster = document.querySelector('.akamai-poster');
//console.log('video Player paused: '+videoPlayer.paused);
//console.log('video PlayerScreen contains(is-paused): '+videoPlayerScreen.classList.contains('is-paused'));

    /*if(videoPlayerScreen.classList.contains('is-paused')){
      videoPlayer.classList.add('akamai-ready');
      videoPlayer.classList.add('akamai-paused');
    } else {videoPlayer.classList.remove('akamai-paused');
      videoPlayer.classList.remove('akamai-ready');
    }*/
  },
  toggle(e) {
    if(e.target.nodeName === 'OBJECT') return; // ignore events that are bubbling from the flash player
    // VideoActions.toggle();
    /*$('.akamai-play.akamai-overlay').addClass('hide-playlist');
    //console.log('Will check now: ',$('#medscape-akamai-video-container'));

    if($('#medscape-akamai-video-container').hasClass('akamai-ready')){
      //console.log('Video paused: ',VideoStore.state.isPlaying);
    } else if ($('#medscape-akamai-video-container').hasClass('akamai-waiting')){
      //console.log('Video playing: ',VideoStore.state.isPlaying);
    } else {
      //console.log('Video paused and we show icon: ',VideoStore.state.isPlaying);
    }

    if(!$('#medscape-akamai-video-container').hasClass('akamai-waiting')){
      //console.log('Show icon now: ',VideoStore.state.isPlaying);
    }*/
  },
  render() {
    const  { isPlaying, isEnded, videoElementId } = this.props;
    // so that the akamai player works outside of the React render chain
    const akamaiDiv  = "<div class='content' id='" + videoElementId + "'></div>",
        style      = {
          // backgroundImage: isPlaying? null : `url(${video.poster})`
        },
        classes = cx({
                    'video-player-screen': true,
                              'is-paused': !isPlaying,
                               'is-ended': isEnded
                  });
    return (
      <div onTouchEnd={this.toggle}
           onClick={this.toggle}
           id="video_player_screen"
           className={classes}
           style={style}
           dangerouslySetInnerHTML={{__html: akamaiDiv}}></div>
    );
  }
});



// WEBPACK FOOTER //
// ./modules/components/player/screen.jsx